import { useAPI } from "../hooks/useAPI";
import { getCall } from "../constants/apicalls.constant";
import { ENDPOINTS } from "../constants/endpoints.constant";
import { useNavigate } from "react-router";
import { Button, message, Tooltip } from "antd";
import { IconPower } from "@tabler/icons-react";

export const Logout = ({ text, type }: { text: string; type?: string }) => {
  const { trigger } = useAPI<{ status: boolean; message: string }>(
    ENDPOINTS.logout
  );
  const navigate = useNavigate();

  const onLogout = async () => {
    const res = await trigger(getCall());
    if (res?.status) {
      navigate("/login");
    } else {
      message.error(res?.message);
    }
  };
  if (type === "indropdown") {
    return (
      <a
        href='#'
        onClick={(e) => {
          e.preventDefault();
          onLogout();
        }}
      >
        {text}
      </a>
    );
  }
  if (type === "text") {
    return (
      <Tooltip title="Logout">
        <Button
          shape="circle"
          color="default"
          variant="filled"
          icon={<IconPower size={18} />}
          onClick={onLogout}
        />
      </Tooltip>
    );
  } else {
    return (
      <Button type="text" onClick={onLogout}>
        {text}
      </Button>
    );
  }
};
